import React from 'react'
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord'
import Tooltip from '@material-ui/core/Tooltip'
import { green } from '@material-ui/core/colors'
import { isSyncedWithinDays } from '../utils/syncStatus'

export default function SyncWithin7DaysIcon({ lastsynctime }) {
  const synced = isSyncedWithinDays(lastsynctime)

  if (synced) {
    return (
      <Tooltip title="七天內已同步">
        <FiberManualRecordIcon style={{ color: green[500] }} />
      </Tooltip>
    )
  }

  return (
    <Tooltip title="超過七天未同步或無同步紀錄">
      <FiberManualRecordIcon color="secondary" />
    </Tooltip>
  )
}
